<template>
  <g>
    <g clip-path="url(#clip0_15_1109)">
      <path
        d="M16 9.00016V14.0002H18V8.00016C18 6.90016 17.1 6.00016 16 6.00016H10V8.00016H15C15.55 8.00016 16 8.45016 16 9.00016ZM19 16.0002H9C8.45 16.0002 7.99999 15.5502 7.99999 15.0002V5.00016C7.99999 4.45016 7.54999 4.00016 6.99999 4.00016C6.44999 4.00016 5.99999 4.45016 5.99999 5.00016V6.00016H4.99999C4.44999 6.00016 3.99999 6.45016 3.99999 7.00016C3.99999 7.55016 4.44999 8.00016 4.99999 8.00016H5.99999V16.0002C5.99999 17.1002 6.89999 18.0002 7.99999 18.0002H16V19.0002C16 19.5502 16.45 20.0002 17 20.0002C17.55 20.0002 18 19.5502 18 19.0002V18.0002H19C19.55 18.0002 20 17.5502 20 17.0002C20 16.4502 19.55 16.0002 19 16.0002ZM17.66 1.40016C15.99 0.510162 13.83 -0.109838 11.39 0.0401623L15.2 3.85016L16.53 2.52016C19.62 3.98016 21.87 6.89016 22.42 10.3802C22.48 10.7902 22.86 11.0702 23.28 11.0002C23.69 10.9402 23.97 10.5502 23.9 10.1402C23.3 6.34016 20.94 3.14016 17.66 1.40016ZM7.46999 21.4902C4.37999 20.0302 2.13 17.1202 1.58 13.6302C1.52 13.2202 1.13999 12.9402 0.719995 13.0102C0.309995 13.0702 0.029995 13.4602 0.099995 13.8702C0.699995 17.6802 3.05999 20.8802 6.33999 22.6202C8.00999 23.5102 10.17 24.1302 12.61 23.9802L8.8 20.1602L7.46999 21.4902Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_1109">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
